import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { motion } from 'framer-motion';
import { UserForm } from '../../../components/surveys/surveys/client/UserForm';
import { useResponseStore } from '../../../store/responseStore';
import { useResponses } from '../../../hooks/encuestas/useResponses';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { useSettings } from '../../../hooks/useSettings';
import { Button } from '../../../components/surveys/surveys/client/Button';

export const PrivacyPolicy = (props) => {

    const { action } = props;
    const classes = useStyles();
    const [change, setChange] = useState(false);

    const { setDataTreatment, response } = useResponseStore();
    const { saveResponse } = useResponses();
    const  { settings } = useSettings(false);

    if(change) return <UserForm action={ action } />

    const agree = () => {
        setDataTreatment('si');
        setChange(true);
    }

    const disagree = async () => {
        setDataTreatment('no');
        saveResponse(response);
        action();
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1}}
            transition={{ duration: 1.5 }}
        >
            <Grid container className={ classes.containerPolicy } justifyContent='center' alignItems='center'>
                <Grid item xs={ 10 } sm={ 10 } md={ 10 } lg={ 7 } >
                    <h1 className={ classes.title }>
                        { convertirLetraMayus(settings?.msj_tratamiento_datos_encuestas) }
                    </h1>
                </Grid>
            </Grid>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 20 }}>
                <h1 className={ classes.title }>Consulte la política&nbsp;
                    <a 
                        href="https://www.camaracartago.org/politica-de-tratamiento-de-datos-personales" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: "#fff", letterSpacing: 1 }}
                    >aquí</a>
                </h1>
            </div>
           
            <div className={classes.containerBtns}>
                <Button
                    title='Autorizo'
                    action={ agree }
                    breakPoints={ [4,3,2,2] }
                />

                <Button 
                    title='No, gracias'
                    action={ disagree }
                    breakPoints={ [4,3,2,2] }
                    type='text'
                /> 
            </div>
        </motion.div>
    );
}

const useStyles = makeStyles({
    title: {
		color: '#fff',
		textAlign: 'center',
		letterSpacing: 1,
        fontSize: 'clamp(.8rem, 3vw, 1.5rem)',

        '@media all and (orientation: landscape)': { 
            fontSize: 'clamp(.8rem, 3vw, 1.1rem)'
        }
	},
    containerPolicy: {
        overflowY: 'auto',
        maxHeight: window.innerHeight / 1.5,
    },
    containerBtns: {
        marginTop: 40, 
        display: 'flex',
        flexFlow: 'column noWrap',
        gap: 20,
        justifyContent: 'center',
        alignItems: 'center'
    }
});